module.exports = __webpack_public_path__ + "fonts/FreightNeoProBold-Regular.c8fa96c0.otf";